/* eslint-disable import/prefer-default-export */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from "react";
import { HStack } from "./Layout";
import { Typography } from "./Typography";
import { Divider } from "./Divider";
import { IDownChevron, IUpChevron, IWarning } from "./Icons";

type accordionProps = {
  title?: string;
  className?: string;
  headerActions?: React.ReactNode;
  headerClassName?: string;
  isOpened?: boolean;
  errorMessage?: string;
  accordionBody?: React.ReactNode;
};

export const Accordion = (props: accordionProps) => {
  const { title, headerActions, headerClassName, accordionBody, className, isOpened, errorMessage } = props;

  const [isOpen, setOpen] = useState<boolean | undefined>(false);

  useEffect(() => {
    setOpen(isOpened);
  }, [isOpened]);

  return (
    <div className={`accordion ${className}`}>
      <HStack className={`justify-content-between accordion-header ${headerClassName}`}>
        <Typography className="accordion-title">{title || "Title"}</Typography>
        <HStack className="pr-0 justify-content-end">
          {errorMessage && (
            <div style={{ display: "flex", paddingLeft: "10px", margin: "12px" }}>
              <IWarning className="my-1" width="16px" height="16px" style={{ marginRight: "5px" }} />
              <p
                className="error-text"
                style={{
                  marginTop: "6px",
                  marginBottom: "6px",
                  fontWeight: "bold",
                }}
              >
                {errorMessage}
              </p>
            </div>
          )}
          {headerActions}
          {isOpen ? (
            <IUpChevron width="24px" height="24px" onClick={() => setOpen(!isOpen)} />
          ) : (
            <IDownChevron width="24px" height="24px" onClick={() => setOpen(!isOpen)} />
          )}
        </HStack>
      </HStack>
      {isOpen && (
        <>
          <Divider />
          {accordionBody}
        </>
      )}
    </div>
  );
};
